import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cta: {
    id: 'availability-calendar.message-member.cta',
    defaultMessage: 'Message member',
  },
  fnbCta: {
    id: 'availability-calendar.message-member.fnb-cta',
    defaultMessage: 'Message customer',
  },
  text: {
    id: 'availability-calendar.message-member.text',
    defaultMessage: 'You will receive texts to {phoneNumber}. Msg & data rates may apply.',
  },
  changeNumber: {
    id: 'availability-calendar.message-member.change-number',
    defaultMessage: 'Change number',
  },
  phoneNumberDisclaimer: {
    id: 'availability-calendar.message-member.phone-number-disclaimer',
    defaultMessage: 'Provide the phone number you plan to use <icon></icon>',
  },
  phoneNumberTooltip: {
    id: 'availability-calendar.message-member.phone-number-tooltip',
    defaultMessage:
      'The changes will be generally applied for <highlight>Account > Notifications > SMS notifications</highlight>',
  },
  memberContacted: {
    id: 'availability-calendar.message-member.member-contacted',
    defaultMessage:
      'Member is contacted through a temporary proxy number that will expire once the reservation is over. <guidelinesLink>Usage Guidelines</guidelinesLink> apply. <moreLink>Learn more here.</moreLink>',
  },
  outsideContactWindow: {
    id: 'availability-calendar.message-member.outside-contact-window',
    defaultMessage:
      'Messages can’t be initiated for this reservation at this time. <guidelinesLink>Usage Guidelines</guidelinesLink> apply. <moreLink>Learn more here.</moreLink>',
  },
  phoneNumberSave: {
    id: 'availability-calendar.message-member.phone-number-save',
    defaultMessage: 'Save',
  },
  phoneNumberCancel: {
    id: 'availability-calendar.message-member.phone-number-cancel',
    defaultMessage: 'Cancel',
  },
  missingPhoneNumber: {
    id: 'availability-calendar.message-member.missing-phone-number',
    defaultMessage:
      'To text this member, you must provide your number. <guidelinesLink>Usage Guidelines</guidelinesLink> apply. <moreLink>Learn more here.</moreLink>',
  },
  fnbMissingPhoneNumber: {
    id: 'availability-calendar.message-member.fnb-missing-phone-number',
    defaultMessage:
      'To text this customer, you must provide your number. <guidelinesLink>Usage Guidelines</guidelinesLink> apply. <moreLink>Learn more here.</moreLink>',
  },
  provideNumber: {
    id: 'availability-calendar.message-member.provide-number',
    defaultMessage: 'Provide number',
  },
  conversationLimitReached: {
    id: 'availability-calendar.message-member.conversation-limit-reached',
    defaultMessage:
      'You are at your limit for active conversations. Please wait for a previous conversation to expire when the associated reservation ends.',
  },
  wrongAppVersion: {
    id: 'availability-calendar.message-member.wrong-app-version',
    defaultMessage: 'This member might not receive your message till they update their app.',
  },
});
